/* unplugin-vue-components disabled */import { render } from "./xTimerButton.vue?vue&type=template&id=6cba3f64"
import script from "./xTimerButton.vue?vue&type=script&lang=js"
export * from "./xTimerButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__